webpackJsonp([7],{

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['address', 'postal', 'country'],
  data: function data() {
    var _this = this;

    return {
      postalCodes: [],
      isLoading: false,
      formData: {
        country: '',
        postalCode: '',
        line1: '',
        line2: '',
        line3: '',
        line4: '',
        locality: '',
        townCity: '',
        latitude: '',
        longitude: ''
      },
      lastGoodPostal: '',
      validPostal: false,
      filtering: null,
      prefill: {
        original: [],
        filtered: []
      },
      linesUK: [{
        property: 'postalCode',
        label: this.$lang.labels.postalCode,
        required: true
      }, {
        property: 'line1',
        label: this.$lang.labels.line1,
        required: true
      }, {
        property: 'line2',
        label: this.$lang.labels.line2,
        required: false
      }, {
        property: 'line3',
        label: this.$lang.labels.line3,
        required: false
      }, {
        property: 'line4',
        label: this.$lang.labels.line4,
        required: false
      }, {
        property: 'townCity',
        label: this.$lang.labels.townCity,
        required: true
      }, {
        property: 'locality',
        label: this.$lang.labels.locality,
        required: false
      }, {
        property: 'latitude',
        label: this.$lang.labels.latitude,
        required: true
      }, {
        property: 'longitude',
        label: this.$lang.labels.longitude,
        required: true
      }],
      linesAT: [{
        property: 'postalCode',
        label: this.$lang.labels.postalCode,
        required: true
      }, {
        property: 'line1',
        label: this.$lang.labels.line1AT,
        required: true
      }, {
        property: 'line2',
        label: this.$lang.labels.line2AT,
        required: true
      }, {
        property: 'line3',
        label: this.$lang.labels.line3AT,
        required: false
      }, {
        property: 'townCity',
        label: this.$lang.labels.townCity,
        required: true
      }, {
        property: 'latitude',
        label: this.$lang.labels.latitude,
        required: true
      }, {
        property: 'longitude',
        label: this.$lang.labels.longitude,
        required: true
      }],
      required: [function (v) {
        return !!v || _this.$lang.errors.required;
      }],
      valid: false,
      err: ''
    };
  },

  computed: {
    filteredLines: function filteredLines() {
      if (this.country === 'AT') {
        return this.linesAT.filter(function (line) {
          return ['postalCode', 'line1', 'line2', 'line3', 'townCity'].includes(line.property);
        });
      }
      return this.linesUK;
    }
  },
  methods: {
    submit: function submit() {
      var _this2 = this;

      this.err = '';
      if (!this.validPostal) {
        this.err = this.$lang.errors.validPostalOrAddress;
        return;
      }
      var checkAddress = [];
      if (this.country === 'AT') {
        // eslint-disable-next-line max-len
        checkAddress = this.prefill.original.filter(function (address) {
          return _this2.formData.line1 === address.line1 && _this2.formData.line2 === address.line2 && _this2.formData.townCity === address.townCity && _this2.formData.latitude === address.latitude && _this2.formData.longitude === address.longitude;
        });
      }
      if (this.country === 'UK') {
        // eslint-disable-next-line max-len
        checkAddress = this.prefill.original.filter(function (address) {
          return _this2.formData.line1 === address.line1 && _this2.formData.line2 === address.line2 && _this2.formData.townCity === address.townCity && _this2.formData.latitude === address.latitude && _this2.formData.longitude === address.longitude;
        });
      }
      if (checkAddress.length === 0) {
        this.err = this.$lang.errors.validPostalOrAddress;
        return;
      }
      if (!this.formData.country) {
        this.formData.country = this.country;
      }
      this.$emit('submit', this.formData);
    },
    filterPrefill: function filterPrefill(value, target) {
      var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.prefill.original.length === 0) return;
      if (this.country === 'AT' && ['line3'].includes(target)) return;
      this.filtering = target;
      if (!value) {
        this.prefill.filtered = [];
        this.filtering = null;
        return;
      }
      // console.log('filter preffill 2', this.formData.postalCode);
      if (value === 'ALL_VALUES') {
        if (clear) {
          this.formData[target] = '';
        }
        this.prefill.filtered = this.prefill.original;
        return;
      }
      this.prefill.filtered = this.prefill.original.filter(function (address) {
        // eslint-disable-next-line max-len
        if (address[target] && address[target].toLowerCase().includes(value.toLowerCase().trim())) return address;
        return false;
      });
      // console.log('filter preffill 4', this.formData.postalCode);
    },
    getPrefill: function getPrefill(value, valueEvent, target) {
      var _this3 = this;

      if (target === 'postalCode') {
        this.getPostalCodes(valueEvent);
        return;
      }
      this.validPostal = false;
      this.prefill = {
        original: [],
        filtered: []
      };
      this.err = '';
      if (this.lastGoodPostal !== '' && this.lastGoodPostal !== value) {
        this.lastGoodPostal = '';
        this.formData.line1 = '';
        if (this.country === 'AT') {
          this.formData.line2 = '';
          this.formData.line3 = '';
          this.formData.townCity = '';
        }
      }
      if (!value) return;
      if (this.country === 'UK' && (value.length < 5 || value.length > 16)) return;
      if (this.country === 'AT' && value.length !== 4) return;
      if ((!value || this.formData.line1.length < 3) && this.country === 'AT') return;
      // eslint-disable-next-line max-len
      var payload = { postalCode: value.trim().toUpperCase(), line1: this.formData.line1, country: this.country };
      this.formData.postalCode = value.trim().toUpperCase();
      this.isLoading = true;
      this.$http.post('address/search', payload).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.validPostal = true;
          _this3.lastGoodPostal = value;
          _this3.prefill.original = res.body.addresses.map(function (current) {
            var address = current;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(address).forEach(function (key) {
              address[key] = address[key].trim();
            });
            return address;
          });
          if (_this3.filterUniqueFields(_this3.prefill.original, 'townCity').length === 1) {
            _this3.formData.townCity = _this3.filterUniqueFields(_this3.prefill.original, 'townCity')[0];
          }
          _this3.isLoading = false;
          _this3.filterPrefill(valueEvent, target);
          return;
        }
        _this3.isLoading = false;
        _this3.validPostal = false;
      }).catch(function (err) {
        _this3.isLoading = false;
      });
    },
    getPostalCodes: function getPostalCodes(code) {
      var _this4 = this;

      this.err = '';
      this.validPostal = false;
      if (!code) return;
      this.formData.postalCode = code.trim().toUpperCase();
      code = code.replace(/\s/g, '');
      if (this.country === 'UK' && (code.length < 4 || code.length > 16)) return;
      if (this.country === 'AT' && code.length !== 4) return;
      this.isLoading = true;
      this.$http.post('address/validatepostalcode/' + this.country + '/' + code).then(function (res) {
        if (res.body && res.status === 200) {
          _this4.isLoading = false;
          _this4.filtering = null;
          _this4.validPostal = true;
          _this4.postalCodes = [];
          setTimeout(function () {
            document.getElementById('1').focus();
          }, 50);
        }
      }).catch(function (err) {
        _this4.err = err.body.status + ', ' + _this4.$lang.errors.postal;
        _this4.isLoading = false;
      });
    },
    setPostalCode: function setPostalCode(code) {
      this.validPostal = true;
      this.lastGoodPostal = code;
      this.formData.postalCode = code;
      this.formData.line1 = '';
      this.formData.line2 = '';
      this.formData.line3 = '';
      this.formData.latitude = '';
      this.formData.longitude = '';
      this.filtering = 'line1';
      this.getPrefill(this.formData.postalCode, '', 'line1');
      setTimeout(function () {
        document.getElementById('1').focus();
      }, 500);
    },
    replaceAddress: function replaceAddress(address, property) {
      var _this5 = this;

      this.err = '';
      if (this.country === 'UK') {
        this.linesUK.forEach(function (input) {
          if (!address[input.property]) return;
          _this5.formData[input.property] = address[input.property];
        });
      } else if (this.country === 'AT') {
        this.formData[property] = address;
        switch (property) {
          case 'line1':
            this.formData.line2 = '';
            this.formData.line3 = '';
            this.formData.latitude = '';
            this.formData.longitude = '';
            setTimeout(function () {
              document.getElementById('2').focus();
            }, 50);
            break;
          // eslint-disable-next-line no-case-declarations
          case 'line2':
            this.formData.line3 = '';
            // eslint-disable-next-line max-len
            var chosenAddress = this.prefill.original.filter(function (x) {
              return x.line1 === _this5.formData.line1 && x.line2 === address;
            });
            if (chosenAddress.length === 0) {
              this.filtering = null;
              this.err = this.$lang.errors.validPostalOrAddress;
              return;
            }
            this.formData.latitude = chosenAddress[0].latitude;
            this.formData.longitude = chosenAddress[0].longitude;
            break;
          case 'line3':
            // code block
            break;
          case 'townCity':
            // code block
            break;
          default:
          // code block
        }
      }
      this.filtering = null;
    },
    filterUniqueFields: function filterUniqueFields(addresses, property) {
      if (this.country === 'UK') return addresses;
      var filteredFieldList = addresses.map(function (address) {
        return address[property];
      });
      // eslint-disable-next-line max-len
      filteredFieldList = filteredFieldList.filter(function (item, index) {
        return filteredFieldList.indexOf(item) === index;
      });
      return filteredFieldList;
    },
    generateAddress: function generateAddress(input) {
      var address = '';
      var tempKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(input);
      tempKeys.forEach(function (key, index) {
        if (['latitude', 'longitude', 'country'].includes(key)) address += '';else if (input[key]) address += tempKeys.length !== index - 1 ? ', ' + input[key].trim() : '' + input[key].trim();
      });
      address = address.substring(2, address.length);
      return address;
    }
  },
  created: function created() {
    var _this6 = this;

    if (typeof this.address !== 'undefined') {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.address).forEach(function (key) {
        _this6.formData[key] = _this6.address[key];
      });
      this.getPrefill(this.formData.postalCode, 'ALL_VALUES', 'line1');
      return;
    }
    if (this.postal) {
      this.formData.postalCode = this.postal.toUpperCase();
      this.getPrefill(this.formData.postalCode, 'ALL_VALUES', 'line1');
      setTimeout(function () {
        document.getElementById('1').focus();
      }, 50);
    } else {
      setTimeout(function () {
        document.getElementById('0').focus();
      }, 200);
    }
  }
});

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".d-none[data-v-ad3cbaba]{display:none}.prefill[data-v-ad3cbaba]{position:relative}.prefill input[data-v-ad3cbaba]{position:relative;z-index:100}.prefill ul[data-v-ad3cbaba]{position:absolute;top:calc(100% - 26px);left:0;list-style:none;padding:0;width:100%;max-height:350px;overflow-y:auto;background:#fff;border:1px solid rgba(0,0,0,.2);z-index:100}.prefill ul li[data-v-ad3cbaba]{position:relative;padding:.5rem;cursor:pointer;transition:background 125ms ease-in}.prefill ul li[data-v-ad3cbaba]:not(:last-child){border-bottom:1px solid rgba(0,0,0,.1)}.prefill ul li[data-v-ad3cbaba]:hover{background:rgba(0,0,0,.05)}.prefill .focus-mask[data-v-ad3cbaba]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99}@media only screen and (max-width:768px){.card__text[data-v-ad3cbaba]{overflow-y:scroll}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/AddressModal.vue"],"names":[],"mappings":"AACA,yBACE,YAAc,CACf,AACD,0BACE,iBAAmB,CACpB,AACD,gCACI,kBAAmB,AACnB,WAAa,CAChB,AACD,6BACI,kBAAmB,AACnB,sBAAuB,AACvB,OAAQ,AACR,gBAAiB,AACjB,UAAW,AACX,WAAY,AACZ,iBAAkB,AAClB,gBAAiB,AACjB,gBAAiB,AACjB,gCAAqC,AACrC,WAAa,CAChB,AACD,gCACM,kBAAmB,AACnB,cAAgB,AAChB,eAAgB,AAChB,mCAAqC,CAC1C,AACD,iDACQ,sCAA4C,CACnD,AACD,sCACQ,0BAAgC,CACvC,AACD,sCACI,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,UAAY,CACf,AACD,yCACA,6BACI,iBAAmB,CACtB,CACA","file":"AddressModal.vue","sourcesContent":["\n.d-none[data-v-ad3cbaba] {\n  display: none;\n}\n.prefill[data-v-ad3cbaba] {\n  position: relative;\n}\n.prefill input[data-v-ad3cbaba] {\n    position: relative;\n    z-index: 100;\n}\n.prefill ul[data-v-ad3cbaba] {\n    position: absolute;\n    top: calc(100% - 26px);\n    left: 0;\n    list-style: none;\n    padding: 0;\n    width: 100%;\n    max-height: 350px;\n    overflow-y: auto;\n    background: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    z-index: 100;\n}\n.prefill ul li[data-v-ad3cbaba] {\n      position: relative;\n      padding: 0.5rem;\n      cursor: pointer;\n      transition: background 125ms ease-in;\n}\n.prefill ul li[data-v-ad3cbaba]:not(:last-child) {\n        border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.prefill ul li[data-v-ad3cbaba]:hover {\n        background: rgba(0, 0, 0, 0.05);\n}\n.prefill .focus-mask[data-v-ad3cbaba] {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 99;\n}\n@media only screen and (max-width: 768px) {\n.card__text[data-v-ad3cbaba] {\n    overflow-y: scroll;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(536);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("36182d1b", content, true, {});

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_vm._v("\n    " + _vm._s(_vm.address ? _vm.$lang.actions.edit : _vm.$lang.actions.add) + " " + _vm._s(_vm.$lang.actions.address) + "\n  ")]), _vm._v(" "), _c('v-card-text', [(!_vm.isLoading) ? _c('div', {
    staticClass: "py-1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n       \n    ")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('v-progress-linear', {
    staticClass: "my-3",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.filteredLines), function(line, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "px-2 prefill",
      class: {
        'd-none': ['latitude', 'longitude'].includes(line.property)
      },
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-wrap",
      attrs: {
        "label": line.label,
        "rules": line.required ? _vm.required : [],
        "type": ['latitude', 'longitude'].includes(line.property) ? 'number' : 'text',
        "color": "primary",
        "id": String(index),
        "hint": line.property === 'line1' && _vm.formData[line.property] === '' ? _vm.$lang.labels.startTyping : '',
        "persistent-hint": ""
      },
      on: {
        "dblclick": function($event) {
          line.property !== 'postalCode' ? _vm.filterPrefill('ALL_VALUES', line.property, true) : ''
        },
        "focus": function($event) {
          line.property === 'postalCode' || (_vm.country === 'AT' && line.property === 'line3') ? _vm.filtering = null : _vm.filterPrefill(_vm.country === 'UK' && _vm.formData[line.property] === '' ? 'ALL_VALUES' : _vm.formData[line.property], line.property)
        },
        "input": function($event) {
          ['postalCode', 'line1'].includes(line.property) ? _vm.getPrefill(_vm.formData.postalCode, $event, line.property) : _vm.filterPrefill($event, line.property)
        },
        "blur": function($event) {
          ['line2'].includes(line.property) && _vm.formData[line.property] !== '' ? _vm.replaceAddress(_vm.formData[line.property], line.property) : ''
        }
      },
      model: {
        value: (_vm.formData[line.property]),
        callback: function($$v) {
          _vm.$set(_vm.formData, line.property, $$v)
        },
        expression: "formData[line.property]"
      }
    }), _vm._v(" "), (!(_vm.country === 'AT' && line.property === 'line3') &&
      _vm.filtering === line.property &&
      _vm.prefill.filtered.length > 0) ? _c('ul', _vm._l((_vm.filterUniqueFields(_vm.prefill.filtered, line.property)), function(filtered, index) {
      return _c('li', {
        key: index,
        on: {
          "click": function($event) {
            return _vm.replaceAddress(filtered, line.property)
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.country === 'UK' ? _vm.generateAddress(filtered) : filtered) + "\n              ")])
    }), 0) : _vm._e(), _vm._v(" "), (line.property === 'postalCode' &&
      _vm.filtering === line.property &&
      _vm.postalCodes.length > 0) ? _c('ul', _vm._l((_vm.postalCodes), function(filtered, index) {
      return _c('li', {
        key: index,
        on: {
          "click": function($event) {
            return _vm.setPostalCode(filtered)
          }
        }
      }, [_vm._v("\n                " + _vm._s(filtered) + "\n              ")])
    }), 0) : _vm._e(), _vm._v(" "), (
      _vm.filtering === line.property &&
      _vm.prefill.filtered.length > 0) ? _c('div', {
      staticClass: "focus-mask",
      on: {
        "click": function($event) {
          _vm.filtering = null
        }
      }
    }) : _vm._e()], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "color": "error",
      "icon": "warning",
      "value": _vm.err !== ''
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "submit",
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.save) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(596),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ad3cbaba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/7.907f805681ffde714f5b.js